import bulmaAccordion from "bulma-accordion"

document.addEventListener("DOMContentLoaded", function (event) {
  bulmaAccordion.attach()
  if (window.location.hash) {
    const accordian = document.querySelector(window.location.hash + '.accordion')
    if (accordian) {
      accordian.classList.add('is-active')
    }
  }
})